module.exports = __webpack_public_path__ + "img/12.9cab1985.png";